import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { categoryService } from "@/services/categoryService";

export const fetchCategories = createAsyncThunk("category/fetchCategories", async (_, thunkAPI) => {
  try {
    const response = await categoryService.getAllCategories();
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
  }
});

export const fetchCategoriesWithTourCount = createAsyncThunk(
  "category/fetchCategoriesWithTourCount",
  async (_, thunkAPI) => {
    try {
      const response = await categoryService.getCategoriesWithTourCount();
      return response.data.data; // Lấy mảng danh mục từ response.data.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
    }
  }
);

export const fetchCategoryById = createAsyncThunk("category/fetchCategoryById", async (categoryId, thunkAPI) => {
  try {
    const response = await categoryService.getCategoryById(categoryId);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
  }
});

export const createCategory = createAsyncThunk("category/createCategory", async (categoryData, thunkAPI) => {
  try {
    const response = await categoryService.createCategory(categoryData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
  }
});

export const updateCategory = createAsyncThunk("category/updateCategory", async ({ categoryId, categoryData }, thunkAPI) => {
  try {
    const response = await categoryService.updateCategory(categoryId, categoryData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
  }
});

export const deleteCategory = createAsyncThunk("category/deleteCategory", async (categoryId, thunkAPI) => {
  try {
    await categoryService.deleteCategory(categoryId);
    return categoryId;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Lỗi không xác định");
  }
});

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    selectedCategory: null,
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCategoriesWithTourCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesWithTourCount.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategoriesWithTourCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategory = action.payload;
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories.push(action.payload);
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = state.categories.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = state.categories.filter((category) => category.id !== action.payload);
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
